import type { EffectiveFragments, UserFragments } from "../interfaces/User";

interface FragmentsOwner {
  config?: UserFragments;
  fragments?: EffectiveFragments;
}

const systemFragments = (config?: UserFragments): string[] =>
  config?.system_fragments ?? config?.fragments_config ?? [];

/** The list athena-users computed, or the same merge done here for older responses. */
export const effectiveFragments = (user: FragmentsOwner): string[] =>
  user.fragments?.effective ??
  Array.from(
    new Set([
      ...systemFragments(user.config),
      ...(user.config?.user_fragments ?? []),
      ...(user.config?.individual_fragments ?? []),
    ]),
  );
